import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { BillingEstimateEffects } from './store/billing-estimate/billing-estimate.effects';
import {
  BillingEstimateNamespace,
  BillingEstimateReducer,
} from './store/billing-estimate/billing-estimate.store';
import { BillingPlansEffects } from './store/billing-plans/billing-plans.effects';
import {
  BillingPlansNamespace,
  BillingPlansReducer,
} from './store/billing-plans/billing-plans.store';

@NgModule({
  imports: [
    StoreModule.forFeature(BillingPlansNamespace, BillingPlansReducer),
    StoreModule.forFeature(BillingEstimateNamespace, BillingEstimateReducer),
    EffectsModule.forFeature([BillingPlansEffects, BillingEstimateEffects]),
  ],
})
export class BillingPlansDataModule {}
